import {Link} from "react-router";

import {Section} from "@/components/section/Section.tsx";
import {ReportDisplaySection} from "@/pages/analyzer/Analyzer.types.ts";
import {getReportTag} from "@/pages/analyzer/Analyzer.utils.ts";
import {AnalyzerReportRow} from "@/pages/analyzer/components/AnalyzerReportRow.tsx";
import {AnalyzerReportTable} from "@/pages/analyzer/components/AnalyzerReportTable.tsx";

import styles from "./AnalyzerReportSection.module.scss";

export const AnalyzerReportSection = ({title, icon, intro, link, rows, tables}: ReportDisplaySection) => {
  const hasTags = rows.some((row) => getReportTag(row) !== undefined);

  return (
    <Section
      title={title}
      icon={icon}
      collapsible={false}
      aria-label={title}
      headerProps={{role: "heading", "aria-level": 3}}
    >
      <div className={styles.content}>
        {(intro || link) && (
          <div className={styles.intro}>
            {intro}
            {link && (
              <Link to={link.to} target="_blank" rel="noopener noreferrer" className="pulseTextLink">
                {link.label}
              </Link>
            )}
          </div>
        )}
        {rows.length > 0 && (
          <div className={styles.rows}>
            {rows.map((row, index) => (
              <AnalyzerReportRow key={`${row.label}-${index}`} row={row} separated={hasTags} />
            ))}
          </div>
        )}
        {tables?.map((table, index) => (
          <AnalyzerReportTable key={table.title ?? index} {...table} />
        ))}
      </div>
    </Section>
  );
};
